import React, {Fragment} from 'react'
import {useUserPreferences} from '@data/queries/preferences/userPreferences.main'
import {useWebsiteMenuInformation} from '@data/queries/website/websiteMenuInformation.main'
import CategoryCPG from '@page-components/Order/LongOrCompactCPG/Categories/CategoryCPG'
import useLayout from '@page-components/Order/useLayout'
import useProductsLayout from '@page-components/Order/useProductsLayout'

import MultiBrandCategoryCPG from './MultiBrandCategoryCPG'

export interface Props {
  categories: any
  categoryRef: any
  sorting: any
  shouldHidePrice: any
}

export default function Categories(props: Props) {
  const {website} = useWebsiteMenuInformation()
  const data = useUserPreferences()
  const {menuId, storeId, deliverAt} = data
  const productsLayout = useProductsLayout(website)
  const layout = useLayout()

  const {categories, shouldHidePrice, sorting} = props

  return website?.isMultiBrand ? (
    <MultiBrandCategoryCPG
      {...props}
      website={website}
      menuId={menuId}
      storeId={storeId}
      deliverAt={deliverAt}
    />
  ) : (
    categories?.items?.map(category => (
      <Fragment key={category._id}>
        <CategoryCPG
          productsLayout={productsLayout}
          layout={layout}
          categoryId={category._id}
          menuId={menuId}
          hidePrice={shouldHidePrice}
          sorting={sorting}
          storeId={storeId}
          deliverAt={deliverAt}
        />
      </Fragment>
    ))
  )
}
